import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PendingDocumentsCustomer } from 'src/app/demo/models/common-data-types';
import { CustomersService } from 'src/app/demo/service/customers.service';
import { LanguageService } from 'src/app/demo/service/language.service';
import { ProgressLoaderService } from 'src/app/demo/service/progress-loader.service';

@Component({
    selector: 'app-pending-documents-customers-list',
    standalone: true,
    imports: [CommonModule, ButtonModule, TableModule, TranslateModule],
    templateUrl: './pending-documents-customers-list.component.html',
    styleUrl: './pending-documents-customers-list.component.scss',
})
export class PendingDocumentsCustomersListComponent {
    customerService = inject(CustomersService);
    translate = inject(TranslateService);
    languageService = inject(LanguageService);
    loadingService = inject(ProgressLoaderService);
    router = inject(Router);

    customers = signal<PendingDocumentsCustomer[]>([]);
    totalRecords = signal<number>(0);
    currentPage = signal<number>(0);
    pageSize = signal<number>(20);
    firstPage = signal(false);
    lastPage = signal(false);
    selectedLanguage!: any;

    ngOnInit() {
        this.fetchCustomersWithPendingDocuments();
        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    fetchCustomersWithPendingDocuments() {
        this.loadingService.show();
        this.customerService
            .fetchCustomersWithOutstandingDocuments(this.currentPage(),this.pageSize())
            .subscribe({
                next: (value) => {
                    this.loadingService.hide();
                    this.customers.set(value.content);
                    this.firstPage.set(value.first);
                    this.currentPage.set(value.number);
                    this.lastPage.set(value.last);
                },
                error: (err) => {
                    this.loadingService.hide();
                },
            });
    }

    paginate(event: any) {
      console.log(event)
        if (
            (this.firstPage() && !this.lastPage()) ||
            (!this.firstPage() && !this.lastPage())
        ) {
            this.currentPage.update((value) => value + 1);
            this.fetchCustomersWithPendingDocuments();
        } else {
            return;
        }
    }

    goToCustomerView(customerId: number) {
        this.router.navigate([
            '/home/customers/'.concat(customerId.toString()),
        ]);
    }
}
